module.exports = require("@amplication/code-gen-types");